// BGPoll Design System Constants

export const colors = {
  bg: "#F8F7F4",
  card: "#FFF",
  border: "#E5E4E1",
  hover: "#F2F1EE",
  text: "#1A1A1A",
  textSec: "#6B6B6B",
  textTer: "#9B9B9B",
  green: "#16A34A",
  greenBg: "#F0FDF4",
  greenBorder: "#BBF7D0",
  red: "#DC2626",
  redBg: "#FEF2F2",
  redBorder: "#FECACA",
  blue: "#2563EB",
  blueBg: "#EFF6FF",
  blueBorder: "#BFDBFE",
};

export const fonts = {
  display: "'Source Serif 4', serif",
  body: "'IBM Plex Sans', sans-serif",
  mono: "'IBM Plex Mono', monospace",
};

export const DEFAULT_CATEGORIES = [
  { id: "all", label: "Всички", icon: "🔮", color: "#6B7280", bg_color: "#F3F4F6" },
];

export const TIERS = [
  { id: "free", name: "Безплатен", icon: "🌱", threshold: 0, color: "#9B9B9B" },
  { id: "active", name: "Активен", icon: "⚡", threshold: 10, color: "#2563EB" },
  { id: "insider", name: "Инсайдер", icon: "🔑", threshold: 100, color: "#7C3AED" },
  { id: "oligarch", name: "Олигарх", icon: "💎", threshold: 500, color: "#D97706" },
];

export const TURNSTILE_SITE_KEY = "Y0x4AAAAAACsCi8wEFjI4qmwQ";
export const GOOGLE_CLIENT_ID =
  "829037765380-v0jl0enm5fbrr0qij7uqg8f3n9hb7r0i.apps.googleusercontent.com";

export const LOGO_BLACK = "/BGPollBlack.png";
export const LOGO_WHITE = "/BGPollWhite.png";
